module.exports = __webpack_public_path__ + "static/img/0004-A-01.2a70812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0004-A-01.jpg
// module id = abfw
// module chunks = 0